<template>
  <SogForm ref="_form">
    <SogFormField>
      <SogTextBox
        v-model="_value"
        placeholder="Bemerkung"
        multiline="true"
        width="200px"
        @update:model-value="onUpdate"
      />
    </SogFormField>
  </SogForm>
</template>

<script setup lang="ts">
import {watch, withDefaults} from "vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {ref} from "vue";

interface Props {
  modelValue?: string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
});
const _form = ref<InstanceType<typeof SogForm> | null>(null);

const _value = ref<string | undefined>(undefined);
const _emits = defineEmits(["update:modelValue"]);
watch(
  props,
  () => {
    _value.value = props.modelValue;
  },
  {immediate: true}
);
const validate = (): boolean => {
  if (_form.value) return _form.value.validate();
  return false;
};

function onUpdate(args: any) {
  _emits("update:modelValue", args);
}

defineExpose({
  validate,
});
</script>

<style scoped></style>
